import React, { useMemo, useState } from "react";
import { generateDemandLetter } from "../../tools/generators/demandLetterGenerator";
import { useLanguage } from "../../contexts/LanguageContext";

const DemandLetterTool = ({ initialValues = {} }) => {
  const { t } = useLanguage();
  const [copied, setCopied] = useState(false);
  const [form, setForm] = useState({
    creditorName: initialValues.creditorName || "",
    debtorName: initialValues.debtorName || "",
    amount: initialValues.amount || "",
    claimBasis: initialValues.claimBasis || "",
    dueDate: initialValues.dueDate || "",
    paymentPeriodDays: initialValues.paymentPeriodDays || "7",
    notes: initialValues.notes || "",
  });

  const output = useMemo(() => generateDemandLetter(form), [form]);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(output.letter);
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    } catch (_error) {
      setCopied(false);
    }
  };

  return (
    <section className="tools-panel">
      <h2 className="tools-panel-title">{t("tools.demand.title")}</h2>
      <p className="tools-panel-subtitle">
        {t("tools.demand.subtitle")}
      </p>

      <div className="tools-grid">
        <label className="tools-field">
          <span>{t("tools.demand.field.creditorName")}</span>
          <input
            name="creditorName"
            value={form.creditorName}
            onChange={handleChange}
            placeholder={t("tools.demand.placeholder.creditorName")}
          />
        </label>

        <label className="tools-field">
          <span>{t("tools.demand.field.debtorName")}</span>
          <input
            name="debtorName"
            value={form.debtorName}
            onChange={handleChange}
            placeholder={t("tools.demand.placeholder.debtorName")}
          />
        </label>

        <label className="tools-field">
          <span>{t("tools.demand.field.amount")}</span>
          <input
            type="number"
            min="0"
            name="amount"
            value={form.amount}
            onChange={handleChange}
            placeholder={t("tools.demand.placeholder.amount")}
          />
        </label>

        <label className="tools-field">
          <span>{t("tools.demand.field.claimBasis")}</span>
          <input
            name="claimBasis"
            value={form.claimBasis}
            onChange={handleChange}
            placeholder={t("tools.demand.placeholder.claimBasis")}
          />
        </label>

        <label className="tools-field">
          <span>{t("tools.demand.field.dueDate")}</span>
          <input type="date" name="dueDate" value={form.dueDate} onChange={handleChange} />
        </label>

        <label className="tools-field">
          <span>{t("tools.demand.field.paymentPeriodDays")}</span>
          <input
            type="number"
            min="1"
            name="paymentPeriodDays"
            value={form.paymentPeriodDays}
            onChange={handleChange}
            placeholder={t("tools.demand.placeholder.paymentPeriodDays")}
          />
        </label>
      </div>

      <label className="tools-field tools-field-wide">
        <span>{t("tools.demand.field.notes")}</span>
        <textarea
          rows={4}
          name="notes"
          value={form.notes}
          onChange={handleChange}
          placeholder={t("tools.demand.placeholder.notes")}
        />
      </label>

      <div className="tools-result-card demand-letter-card">
        <div className="demand-letter-actions">
          <span className="tools-result-label">{t("tools.demand.result.finalText")}</span>
          <button className="tools-primary-btn" onClick={handleCopy} type="button">
            {copied ? t("tools.demand.action.copied") : t("tools.demand.action.copy")}
          </button>
          <button className="tools-primary-btn" onClick={() => window.print()} type="button">
            {t("tools.demand.action.print")}
          </button>
        </div>
        <pre className="demand-letter-text">{output.letter}</pre>
      </div>
    </section>
  );
};

export default DemandLetterTool;

